<template>
  <div class="main-content">
    <div v-if="showFlag">
      <el-form :inline="true" :model="searchForm" class="form-content">
        <el-row :gutter="20" class="slt"
          :style="{ justifyContent: contents.searchBoxPosition == '1' ? 'flex-start' : contents.searchBoxPosition == '2' ? 'center' : 'flex-end' }">
          <el-form-item :label="contents.inputTitle == 1 ? '字段名称' : ''">
            <el-input v-model="searchForm.fieldName" placeholder="字段名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="search()">查询</el-button>
          </el-form-item>
        </el-row>
        <el-row class="ad">
          <el-form-item>
            <el-button v-if="isAuth('formField', '新增')" type="success" icon="el-icon-plus" @click="addOrUpdateHandler()">新增</el-button>
            <el-button v-if="isAuth('formField', '删除') && contents.tableSelection"
              :disabled="dataListSelections.length <= 0" type="danger" icon="el-icon-delete" @click="deleteHandler()">删除</el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="table-content">
        <el-table class="tables" :data="dataList" v-loading="dataListLoading"
          @selection-change="selectionChangeHandler">
          <el-table-column v-if="contents.tableSelection" type="selection" align="center" width="50">
          </el-table-column>
          <el-table-column label="索引" v-if="contents.tableIndex" type="index" width="50" />
          <el-table-column prop="fieldLabel" label="字段标签" width="200">
          </el-table-column>
          <el-table-column prop="fieldName" label="字段名称" width="200">
          </el-table-column>
          <el-table-column prop="fieldType" label="字段类型" width="150">
            <template slot-scope="scope">
              {{ getFieldTypeName(scope.row.fieldType) }}
            </template>
          </el-table-column>
          <el-table-column prop="required" label="必填" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.required == 1">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">启用</span>
              <span v-else>禁用</span>
            </template>
          </el-table-column>
          <el-table-column prop="sorts" label="排序" width="120">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.sorts" type="number" @blur="updateSorts(scope.row)" style="width: 80px;">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column width="250" label="操作">
            <template slot-scope="scope">
              <el-button v-if="isAuth('formField', '查看')" type="success" icon="el-icon-tickets" size="mini" @click="addOrUpdateHandler(scope.row.id, 'info')">详情</el-button>
              <el-button v-if="isAuth('formField', '修改')" type="primary" icon="el-icon-edit" size="mini" @click="addOrUpdateHandler(scope.row.id)">修改</el-button>
              <el-button v-if="isAuth('formField', '删除')" type="danger" icon="el-icon-delete" size="mini" @click="deleteHandler(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page-size.sync="pageSize" :page.sync="pageNum" @pagination="queryList" />
      </div>
    </div>
    <add-or-update v-if="addOrUpdateFlag" ref="addOrUpdate" @refreshDataList="queryList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from './add-or-update.vue'
export default {
  name: 'FormFieldList',
  components: { AddOrUpdate },
  data() {
    return {
      showFlag: true,
      addOrUpdateFlag: false,
      dataList: [],
      dataListLoading: false,
      dataListSelections: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      searchForm: {
        fieldName: ''
      },
      contents: {
        tableSelection: true,
        tableIndex: true
      }
    }
  },
  methods: {
    getFieldTypeName(type) {
      const types = {
        'text': '文本输入',
        'textarea': '多行文本',
        'number': '数字',
        'select': '下拉选择',
        'radio': '单选',
        'checkbox': '多选',
        'date': '日期',
        'phone': '手机号'
      }
      return types[type] || type
    },
    updateSorts(row) {
      this.$http({
        url: "formField/update",
        method: "post",
        data: { id: row.id, sorts: row.sorts }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message.success("排序更新成功");
          this.queryList();
        } else {
          this.$message.error(data.msg || "更新失败");
        }
      });
    },
    init() {
      this.showFlag = true;
      this.addOrUpdateFlag = false;
      this.queryList();
    },
    queryList() {
      this.dataListLoading = true;
      this.$http({
        url: "formField/page",
        method: "get",
        params: {
          page: this.pageNum,
          limit: this.pageSize,
          fieldName: this.searchForm.fieldName
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list;
          this.total = data.data.total;
        } else {
          this.dataList = [];
          this.total = 0;
        }
        this.dataListLoading = false;
      });
    },
    search() {
      this.pageNum = 1;
      this.queryList();
    },
    addOrUpdateHandler(id, type) {
      this.addOrUpdateFlag = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, type);
      });
    },
    deleteHandler(id) {
      var ids = id ? [id] : this.dataListSelections.map(item => item.id);
      this.$confirm('确定删除选中记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: "formField/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message.success('删除成功');
            this.queryList();
          } else {
            this.$message.error(data.msg || '删除失败');
          }
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    isAuth(tableName, btnName) {
      return true;
    }
  },
  mounted() {
    this.init();
  }
}
</script>